import React, { useState, useContext, useEffect } from 'react';

import { ChevronDownIcon, ChevronUpIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { CountTypesToSymbol } from '../../../queue-card/QueueCard';
import { QueueContext } from '../../../queue-context/QueueContext';
import st from './GroupedCheckbox.module.sass';

function transformDescriptionToLabel(description) {
  const { zone_count_type, zone_count_threshold } = JSON.parse(description);
  if (!zone_count_threshold) return '';
  return `${CountTypesToSymbol[zone_count_type]} ${zone_count_threshold}`;
}

function GroupedCheckbox({ groupName, setSelectedStreams, selectedStreams }) {
  const { streams } = useContext(QueueContext);
  const isAnyStreamFromGroupSelected = streams[groupName].some((s) => selectedStreams.includes(s.stream_id));
  const [isOpen, setIsOpen] = useState(isAnyStreamFromGroupSelected);
  const { t } = useTranslation();
  const resolvedGroupName = groupName === 'no_group' ? t('queue:queue group card.streams with no group') : groupName;

  useEffect(() => {
    // если какая-то из очередей выбрана снаружи,- делаем группу сразу открытой
    setIsOpen(isAnyStreamFromGroupSelected);
  }, [isAnyStreamFromGroupSelected]);

  const handleSelectAll = () => {
    const groupIds = streams[groupName].map((s) => s.stream_id);
    const selectedGroupIds = selectedStreams.filter((id) => groupIds.includes(id));

    if (selectedGroupIds.length === groupIds.length) {
      setSelectedStreams((prev) => prev.filter((id) => !groupIds.includes(id)));
    } else if (selectedGroupIds.length > 0) {
      const newIds = groupIds.filter((id) => !selectedStreams.includes(id));
      setSelectedStreams((prev) => [...prev, ...newIds]);
    } else {
      setSelectedStreams((prev) => [...prev, ...groupIds]);
    }
  };

  const handleChange = (e) => {
    if (selectedStreams.includes(e.target.value)) {
      setSelectedStreams((prev) => prev.filter((item) => item !== e.target.value));
    } else {
      setSelectedStreams((prev) => [...prev, e.target.value]);
    }
  };

  return (
    <div className={st.Wrapper}>
      <div className={st.Head}>
        <Control.Checkbox
          checked={streams[groupName].every((s) => selectedStreams.includes(s.stream_id))}
          onChange={handleSelectAll}
          value={streams[groupName].map((s) => s.stream_id)}
        />
        <div className={st.GroupName}>{resolvedGroupName}</div>
        <Control.IconButton
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          kind="secondary"
          onClick={() => setIsOpen((p) => !p)}
          size="small"
          type="button"
          variant="dimmed"
        />
      </div>
      {isOpen && (
        <div className={st.CheckboxList}>
          {streams[groupName].map((stream) => (
            <div
              className={st.OneStream}
              key={stream.stream_id}
            >
              <Control.Checkbox
                checked={selectedStreams.includes(stream.stream_id)}
                onChange={handleChange}
                value={stream.stream_id}
              />
              <div className={st.StreamName}>{stream.name || stream.stream_id}</div>
              <span className={st.CountType}>{transformDescriptionToLabel(stream.description)}</span>
            </div>
          ))}
        </div>
      )}
    </div>

  );
}

export { GroupedCheckbox };
